import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '@/components/pages/settings-page'
import { requireAuth } from '@/lib/route-guards'

export const Route = createFileRoute('/settings')({
  beforeLoad: requireAuth,
  component: SettingsPage,
  head: () => ({
    meta: [
      { title: 'Settings — mkdn.app' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
})
